
import { FaArrowRight } from 'react-icons/fa6';
import { useSelector } from 'react-redux';
import { retrunAssets } from '../../utils/getAssets';

const AcademicsLinks = () => {


    const state = useSelector(state => state.academicCalendarItems)
   


    const academicLinks = state?.data?.properties

    const title = academicLinks?.title
    const description = academicLinks?.description
    const links = academicLinks?.calendarDownloadButtons?.items?.map(item => {
        item = item?.content?.properties
        return {
            name: item?.label,
            url: item?.buttonDownload != null ? retrunAssets(item?.buttonDownload[0]?.url) : ""
        }
    })
   


    return (
        <div className="grid gap-4">
            <h1 className="text-4xl font-bold   text-slate-900">{title}</h1>
            <p className="text-slate-600 font-normal">{description}</p>
            <div className="grid gap-4">
                {links?.map((link, index) => (
                    <a key={index} href={link?.url} download={link?.url} className="text-blue-600 flex items-center gap-2 font-bold uppercase cursor-pointer">{link?.name} <FaArrowRight /></a>
                ))}
            </div>
        </div>
    )
}

export default AcademicsLinks